<template>
  <div v-if="devices?.length" class="dropdown" v-click-outside="closeDropdown">
    <button class="btn btn-lg dropdown-toggle w-100 d-flex justify-content-between align-items-center monospaced"
            type="button" 
            @click="toggleDropdown" 
            :aria-expanded="isOpen">
      <span v-if="selectedId !== null"> {{ selectedDevice?.emoji }} {{ selectedDevice?.name }}</span>
      <span class="text-muted" v-if="selectedId === null"><i class="fa-solid fa-server"></i> Select a device</span>
    </button>
    <ul class="dropdown-menu w-100 mt-1" :class="{ 'show': isOpen }">
      <li v-for="device in devices" 
          :key="device.id">
        <a class="dropdown-item" 
           href="#" 
           :class="{ 'active': device.id === selectedId }" 
           @click.prevent="selectDevice(device)">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <div><b>{{ device.name }}</b></div>
            </div>
            <div class="text-end">
              <small class="text-muted me-2">{{ device.location}}</small>
              <span>{{ device.emoji }}</span>
            </div>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'DeviceSelector',
  computed: {
    selectedDevice() {
      return this.devices.find(device => device.id === this.selectedId)
    }
  },
  props: {
    devices: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      selectedId: null,
      isOpen: false
    }
  },
  directives: {
    'click-outside': {
      mounted(el, binding) {
        el.clickOutsideEvent = function(event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event);
          }
        };
        document.addEventListener('click', el.clickOutsideEvent);
      },
      unmounted(el) {
        document.removeEventListener('click', el.clickOutsideEvent);
      }
    }
  },
  methods: {
    selectDevice(device) {
      this.selectedId = device.id
      this.$emit('device-selected', device)
      this.isOpen = false
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen
    },
    closeDropdown() {
      this.isOpen = false
    }
  }
}
</script>

<style scoped>
.dropdown-menu {
  max-height: 400px;
  overflow-y: auto;
  transform-origin: top;
  transition: all 0.1s ease-out;
  opacity: 0;
  transform: scaleY(0.9);
  display: block;
  pointer-events: none;
}

.dropdown-menu.show {
  opacity: 1;
  transform: scaleY(1);
  pointer-events: auto;
}

.dropdown-item {
  padding: 0.75rem 1rem;
  white-space: normal;
}

.dropdown-item.active,
.dropdown-item:active {
  background-color: var(--bs-primary);
  color: white;
}

.dropdown-item.active small,
.dropdown-item:active small {
  color: rgba(255, 255, 255, 0.75) !important;
}
.dropdown-toggle{
  background-color: var(--bs-body-bg);
  color: var(--bs-body-color);
  border: var(--bs-border-width) solid var(--bs-border-color);
  transition: outline 0.15s ease-in-out;
}

.dropdown-toggle[aria-expanded="true"] {
  border-color: var(--bs-primary);
  outline: 0;
  box-shadow: 0 0 0 .25rem rgba(13,110,253,.25);
}
</style>